import { useAuth } from './useAuth';

export function useSubscription() {
  const { userProfile } = useAuth();

  const isPro =
    userProfile?.plan === 'pro' && userProfile?.subscription?.status === 'active';

  const isActive = userProfile?.subscription?.status === 'active';

  const canDownload = true;

  const downloadsRemaining = Infinity;

  const subscriptionStatus = userProfile?.subscription?.status || 'none';

  const currentPeriodEnd = userProfile?.subscription?.currentPeriodEnd;

  return {
    isPro,
    isActive,
    canDownload,
    downloadsRemaining,
    subscriptionStatus,
    currentPeriodEnd,
    plan: userProfile?.plan || 'free',
  };
}
